import { Breadcumb, MainLayout } from 'components';
import Header from 'components/header/header';
import Loader from 'components/UI/loader/loader';
import FinancialBody from 'pages/FinancialData/FinancialBody';
import React, { FC, useEffect, useState } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { cnpjMask } from 'utils';
import AlertModal from '../../modals/alert-modal/alert-modal';
import FinancialAccountModal from '../../modals/FinancialAccountModal';
import FinancialDataService from '../../services/FinancialData/FinancialData';
import FinancialItem from './FinancialItem';
import {
  CardHeaderStyled,
  CardStyled,
  ColContainer,
  LoaderContainer,
  Text,
  TextNotification,
  Title,
  TitleContainer,
} from './style';

const FinancialData: FC = () => {
  const [alertOpen, setAlertOpen] = useState(false);
  const [modalDataOpen, setModalDataOpen] = useState(false);
  const [modalData, setModalData] = useState({});
  const [alertMessage, setAlertMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [financialData, setfinancialData] = useState([]);

  const load = () => {
    setIsLoading(true);
    FinancialDataService.getData().then(
      (result) => {
        setfinancialData(result);
        setIsLoading(false);
      },
      (error) => {
        setAlertMessage(
          'Ocorreu um erro ao tentar obter os dados. Tente novamente.',
        );
        setIsLoading(false);
        setAlertOpen(true);
      },
    );
  };

  const openModal = (data: any, index) => {
    const modalDataIndex = {
      data,
      index,
    };

    setModalData(modalDataIndex);
    setModalDataOpen(true);
  };

  const onCloseDataModal = () => {
    setModalData({});
    setModalDataOpen(false);
  };

  const onEditedAccount = (message, data, index) => {
    setAlertMessage(message);
    setAlertOpen(true);

    if (data) {
      const newFinancialData: any = [...financialData] as any;
      newFinancialData[index] = data;
      setfinancialData(newFinancialData);
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <MainLayout>
      <Breadcumb />
      <Header />
      <Container>
        <Row>
          <ColContainer>
            <h2>Dados Financeiros</h2>
            {isLoading && (
              <LoaderContainer>
                <Loader show={isLoading} />
              </LoaderContainer>
            )}
            <Accordion defaultActiveKey="0">
              {financialData?.map((item: any, i) => (
                <CardStyled key={i}>
                  <CardHeaderStyled>
                    <FinancialItem
                      eventKey={`${i}-acc`}
                      onEditCallback={() => {
                        openModal(item, i);
                      }}
                    >
                      <TitleContainer>
                        <Title>CNPJ</Title>
                        <Text>{cnpjMask(item.cnpj)}</Text>
                      </TitleContainer>
                    </FinancialItem>
                  </CardHeaderStyled>
                  <Accordion.Collapse eventKey={`${i}-acc`}>
                    <FinancialBody body={item} />
                  </Accordion.Collapse>
                </CardStyled>
              ))}
            </Accordion>

            <TextNotification>
              A <span>edição dos dados financeiros</span> está sendo atualizada. Enquanto isso, <a href='https://share.hsforms.com/1nKgsbZSYS_SsH46jp0jU-w520y9' target='_blank'>clique aqui</a> para alterar os dados.
            </TextNotification>

            <AlertModal
              title="Atenção"
              isOpen={alertOpen}
              onClose={() => {
                setAlertOpen(false);
              }}
              message={alertMessage}
            />

            <FinancialAccountModal
              data={modalData}
              isOpen={modalDataOpen}
              onClose={() => onCloseDataModal()}
              onEditedAccount={onEditedAccount}
            />
          </ColContainer>
        </Row>
      </Container>
    </MainLayout>
  );
};

export default FinancialData;
